import React from 'react';
import { useState, useEffect, Fragment } from 'react';
import {
  Card,
  CardHeader,
  Table,
  Container,
  Row,
  Button, Modal, Spinner,
  FormGroup, Label, Input, NavLink, Col, ModalBody, ModalFooter
} from "reactstrap";
import { NavLink as NavLinkRRD, Link, useHistory } from "react-router-dom";
import iconSet from "selection.json";
import IcomoonReact, { iconList } from "icomoon-react";
import dataProvider from "dataProvider";
import auth from "authProvider";
import decodeJwt from 'jwt-decode';

const Settings = (props) => {
  const history = useHistory();
  const [settings, setSettings] = React.useState({});
  const [modalOpen, setModalOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [page, setPage] = useState(1);
  const [more, setMore] = useState(true);
  const [reload, setReload] = useState(false);
  const [peropen, setPeropen] = useState(false)
  const [error, setError] = useState({})
  const [editsucess, setEditsucess] = useState(false);

  const onLogout = () => {
    auth.logout();
    history.push("/")
  }
  const onSettingsUpdate = (params, id) => {
    setLoading(id);
    if (settings[params]) {
      if (!validateEmail(settings.email_1)) {
        setError(params)
        window.location.reload()
        return;
      } else {
        setError(false)
      }
    }
    if (!validateEmail(settings.email_2)) {
      setError(params)
      window.location.reload()
      return;
    } else {
      setError(false)
    }
    if (!validateEmail(settings.email_3)) {
      setError(params)
      window.location.reload()
      return;
    } else {
      setError(false)
    }
    if (!validateEmail(settings.email_4)) {
      setError(params)
      window.location.reload()
      return;
    } else {
      setError(false)
    }
    console.log(settings)
    function validateEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }
    dataProvider.updateSettings('settings', { params: settings })
      .then(({ data }) => {
        setLoading(false)
        setEditsucess(true)
        setTimeout(() => Pushedit(), 2000);
      })
      .catch(error => {
        if (error?.response?.data?.expire === true) {
          setModalOpen(true)
        }
      })
  }
  useEffect(() => {
    let token = localStorage.getItem('token');
    dataProvider.getList('settings', { params: { pagination: { page: page, perPage: 20 }, sort: { order: 'desc', field: 'id' }, filter: {}, token: token } })
      .then(({ data }) => {
        var size = Object.keys(data).length;
        if (size < 20) {
          setMore(false)
        }
        else {
          setMore(true)
        }
        setSettings(data);
      });
  }, [props, reload]);

  const onPagination = (i) => {
    let newPage = page + i;
    if (newPage == 0) {
      return;
    }
    else if (i === 1 && !more) {
      return;
    }
    setPage(newPage);
    setReload(!reload);
  }
  let token = localStorage.getItem('token');
  let per = localStorage.getItem('permission');
  // const decodedToken = decodeJwt(token);
  // const per = decodedToken.user.permissions;

  const perModal = () => {
    setPeropen(true)
  }
  const permodalClose = () => {
    setPeropen(false)
  }
  const Pushedit = () => {
    setEditsucess(false)
    window.location.reload();

  }

  return (
    <>
      <div className="header pb-8 pt-5 pt-md-6" style={{
        width: '100%',
        backgroundImage:
          "url(" +
          require("../../../assets/img/brand/header.jpg").default +
          ")",
      }}>
        <Container fluid >
          <div className="header-body">
            {/* header*/}
            <Row style={{ color: 'white', paddingLeft: '20px' }}>
              <h1 className="mb-0" style={{ color: 'white', alignContent: 'flex-start' }}>SETTINGS</h1>
            </Row>
          </div>
        </Container>
      </div>

      {/* Page content */}
      <Container className="mt--7" fluid>
        {/* Table */}
        <Row style={{ margin: 0 }}>
          <div className="col">
            <Card className="shadow" style={{ borderRadius: 10 }}>
              <CardHeader className="border-0" style={{ display: 'flex', color: 'white', fontSize: '1.25rem', paddingLeft: '20px', flexDirection: 'row', justifyContent: 'space-between' }} >
                <div style={{ alignContent: 'flex-start' }}><h3 style={{ fontSize: 'rem', fontWeight: 'bold' }} className="mb-0">SETTINGS</h3></div>
                <div style={{ alignContent: 'flex-end' }}>
                  {page > 1 || page !== 1 ? <Button onClick={() => onPagination(-1)} style={{ backgroundColor: 'white', fontSize: '0.75rem', height: '2.5rem', padding: '0px', color: 'rgb(66 54 47)', width: '5rem', margin: '0px', borderColor: 'rgb(144 151 153)' }} >
                    <IcomoonReact style={{ paddingRight: 5 }} iconSet={iconSet} color="#77665c" size={11} icon="prev" />PREV</Button>
                    : <Button disabled style={{ backgroundColor: 'white', fontSize: '0.7rem', height: '2.5rem', padding: '0px', color: '#77665c', width: '5rem', margin: '0px', borderColor: '#ccc' }} >
                      <IcomoonReact style={{ paddingRight: 5 }} iconSet={iconSet} color="#77665c" size={10} icon="prev" />PREV</Button>}
                  {more ? <Button onClick={() => onPagination(1)} style={{ backgroundColor: 'white', fontSize: '0.7rem', borderColor: '#ccc', padding: '0px', height: '2.5rem', color: 'rgb(66 54 47)', width: '5rem', borderColor: 'rgb(144 151 153)' }} > NEXT
                    <IcomoonReact style={{ paddingLeft: 5 }} iconSet={iconSet} color="#77665c" size={11} icon="next" /></Button> :
                    <Button disabled style={{ backgroundColor: 'white', fontSize: '0.7rem', borderColor: '#ccc', padding: '0px', height: '2.5rem', color: '#77665c', width: '5rem', borderColor: '#ccc' }} > NEXT
                      <IcomoonReact style={{ paddingLeft: 5 }} iconSet={iconSet} color="#77665c" size={10} icon="next" /></Button>}
                </div>
              </CardHeader>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col" >KEYWORD</th>
                    <th scope="col" style={{ textAlign: 'center' }}>INPUT</th>
                    <th scope="col" style={{ textAlign: 'center', paddingRight: 40, display: 'flex', justifyContent: 'end' }} >ACTION</th>
                  </tr>
                </thead>
                <tbody>
                  <tr style={{ padding: 0 }}>
                    <td style={{ fontWeight: 600 }}>Notification Key</td>
                    <td style={{ padding: 0 }}>
                      <div className="pl-lg-4">
                        <Row style={{ marginTop: 0 }}>
                          <Col md="12" style={{ padding: 10 }}>
                            <div>
                              <Input
                                type="text"
                                style={{ color: '#62635e' }}
                                value={settings.notification_key ? settings.notification_key : ''}
                                onChange={(e) => setSettings({ ...settings, notification_key: e.target.value })}
                              />
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </td>
                    <td>
                      {per.includes('settings_edit') ? <Button disabled={loading === 1} type="submit" onClick={() => onSettingsUpdate('notification_key', 1)} style={{ backgroundColor: loading === 1 ? 'green' : 'rgb(125 227 251)', fontSize: '0.625rem', border: 0, color: 'white', borderRadius: '20px', float: 'right', padding: 8, paddingLeft: '16px', paddingRight: 16 }}>
                        UPDATE</Button> :
                        <Button onClick={() => perModal()} style={{ backgroundColor: 'rgb(125 227 251)', fontSize: '0.625rem', border: 0, color: 'white', borderRadius: '20px', padding: 8, paddingLeft: '16px', paddingRight: 16 }}>
                          UPDATE</Button>}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ fontWeight: 600 }}>Web Notification Key</td>
                    <td style={{ padding: 0 }}>
                      <div className="pl-lg-4">
                        <Row>
                          <Col md="12" style={{ padding: 10 }}>
                            <div>
                              <Input
                                type="text"
                                style={{ color: '#62635e' }}
                                value={settings.web_notification_key ? settings.web_notification_key : ''}
                                onChange={(e) => setSettings({ ...settings, web_notification_key: e.target.value })}
                              />
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </td>
                    <td>
                      {per.includes('settings_edit') ? <Button disabled={loading === 2} type="submit" onClick={() => onSettingsUpdate('web_notification_key', 2)} style={{ backgroundColor: loading === 2 ? 'green' : 'rgb(125 227 251)', fontSize: '0.625rem', border: 0, color: 'white', borderRadius: '20px', float: 'right', padding: 8, paddingLeft: '16px', paddingRight: 16 }}>
                        UPDATE</Button> :
                        <Button onClick={() => perModal()} style={{ backgroundColor: 'rgb(125 227 251)', fontSize: '0.625rem', border: 0, color: 'white', borderRadius: '20px', padding: 8, paddingLeft: '16px', paddingRight: 16 }}>
                          UPDATE</Button>}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ fontWeight: 600 }}>Emergency Number</td>
                    <td style={{ padding: 0 }}>
                      <div className="pl-lg-4">
                        <Row>
                          <Col md="12" style={{ padding: 10 }}>
                            <div>
                              <Input
                                type="text"
                                style={{ color: '#62635e' }}
                                value={settings.emergency_number ? settings.emergency_number : ''}
                                onChange={(e) => setSettings({ ...settings, emergency_number: e.target.value })}
                              />
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </td>
                    <td>
                      {per.includes('settings_edit') ? <Button disabled={loading === 3} type="submit" onClick={() => onSettingsUpdate('emergency_number', 3)} style={{ backgroundColor: loading === 3 ? 'green' : 'rgb(125 227 251)', fontSize: '0.625rem', border: 0, color: 'white', borderRadius: '20px', float: 'right', padding: 8, paddingLeft: '16px', paddingRight: 16 }}>
                        UPDATE</Button> :
                        <Button onClick={() => perModal()} style={{ backgroundColor: 'rgb(125 227 251)', fontSize: '0.625rem', border: 0, color: 'white', borderRadius: '20px', padding: 8, paddingLeft: '16px', paddingRight: 16 }}>
                          UPDATE</Button>}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ fontWeight: 600 }}>Mobile Number 1</td>
                    <td style={{ padding: 0 }}>
                      <div className="pl-lg-4">
                        <Row>
                          <Col md="12" style={{ padding: 10 }}>
                            <div>
                              <Input
                                type="text"
                                style={{ color: '#62635e' }}
                                value={settings.mobile_number_1 ? settings.mobile_number_1 : ''}
                                onChange={(e) => setSettings({ ...settings, mobile_number_1: e.target.value })}
                              />
                            </div>
                          </Col>
                        </Row>
                      </div>
                      {/* {error === 'mobile_number_1' ? <span style={{ color: 'red' }}>{'Enter a valid phone address'}</span> : null} */}
                    </td>
                    <td>
                      {per.includes('settings_edit') ? <Button disabled={loading === 4} type="submit" onClick={() => onSettingsUpdate('mobile_number_1', 4)} style={{ backgroundColor: loading === 4 ? 'green' : 'rgb(125 227 251)', fontSize: '0.625rem', border: 0, color: 'white', borderRadius: '20px', float: 'right', padding: 8, paddingLeft: '16px', paddingRight: 16 }}>
                        UPDATE</Button> :
                        <Button onClick={() => perModal()} style={{ backgroundColor: 'rgb(125 227 251)', fontSize: '0.625rem', border: 0, color: 'white', borderRadius: '20px', padding: 8, paddingLeft: '16px', paddingRight: 16 }}>
                          UPDATE</Button>}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ fontWeight: 600 }}>Mobile Number 2</td>
                    <td style={{ padding: 0 }}>
                      <div className="pl-lg-4">
                        <Row>
                          <Col md="12" style={{ padding: 10 }}>
                            <div>
                              <Input
                                type="text"
                                style={{ color: '#62635e' }}
                                value={settings.mobile_number_2 ? settings.mobile_number_2 : ''}
                                onChange={(e) => setSettings({ ...settings, mobile_number_2: e.target.value })}
                              />
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </td>
                    <td>
                      {per.includes('settings_edit') ? <Button disabled={loading === 5} type="submit" onClick={() => onSettingsUpdate('mobile_number_2', 5)} style={{ backgroundColor: loading === 5 ? 'green' : 'rgb(125 227 251)', fontSize: '0.625rem', border: 0, color: 'white', borderRadius: '20px', float: 'right', padding: 8, paddingLeft: '16px', paddingRight: 16 }}>
                        UPDATE</Button> :
                        <Button onClick={() => perModal()} style={{ backgroundColor: 'rgb(125 227 251)', fontSize: '0.625rem', border: 0, color: 'white', borderRadius: '20px', padding: 8, paddingLeft: '16px', paddingRight: 16 }}>
                          UPDATE</Button>}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ fontWeight: 600 }}>Email 1</td>
                    <td style={{ padding: 0 }}>
                      <div className="pl-lg-4">
                        <Row>
                          <Col md="12" style={{ padding: 10 }}>
                            <div>
                              <Input
                                type="text"
                                style={{ color: '#62635e' }}
                                value={settings.email_1 ? settings.email_1 : ''}
                                onChange={(e) => setSettings({ ...settings, email_1: e.target.value })}
                              />
                            </div>
                            {error === 'email_1' ? <span style={{ color: 'red' }}>{'Enter a valid email address'}</span> : null}
                          </Col>
                        </Row>
                      </div>
                    </td>
                    <td>
                      <Button disabled={loading === 6} type="submit" onClick={() => onSettingsUpdate('email_1', 6)} style={{ backgroundColor: loading === 6 ? 'green' : 'rgb(125 227 251)', fontSize: '0.625rem', border: 0, color: 'white', borderRadius: '20px', float: 'right', padding: 8, paddingLeft: '16px', paddingRight: 16 }}>
                        UPDATE</Button>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ fontWeight: 600 }}>Email 2</td>
                    <td style={{ padding: 0 }}>
                      <div className="pl-lg-4">
                        <Row>
                          <Col md="12" style={{ padding: 10 }}>
                            <div>
                              <Input
                                type="text"
                                style={{ color: '#62635e' }}
                                value={settings.email_2 ? settings.email_2 : ''}
                                onChange={(e) => setSettings({ ...settings, email_2: e.target.value })}
                              />
                            </div>
                            {error === 'email_2' ? <span style={{ color: 'red' }}>{'Enter a valid email address'}</span> : null}
                          </Col>
                        </Row>
                      </div>
                    </td>
                    <td>
                      <Button disabled={loading === 7} type="submit" onClick={() => onSettingsUpdate('email_2', 7)} style={{ backgroundColor: loading === 7 ? 'green' : 'rgb(125 227 251)', fontSize: '0.625rem', border: 0, color: 'white', borderRadius: '20px', float: 'right', padding: 8, paddingLeft: '16px', paddingRight: 16 }}>
                        UPDATE</Button>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ fontWeight: 600 }}>Email 3</td>
                    <td style={{ padding: 0 }}>
                      <div className="pl-lg-4">
                        <Row>
                          <Col md="12" style={{ padding: 10 }}>
                            <div>
                              <Input
                                type="text"
                                style={{ color: '#62635e' }}
                                value={settings.email_3 ? settings.email_3 : ''}
                                onChange={(e) => setSettings({ ...settings, email_3: e.target.value })}
                              />
                            </div>
                            {error === 'email_3' ? <span style={{ color: 'red' }}>{'Enter a valid email address'}</span> : null}
                          </Col>
                        </Row>
                      </div>
                    </td>
                    <td>
                      <Button disabled={loading === 8} type="submit" onClick={() => onSettingsUpdate('email_3', 8)} style={{ backgroundColor: loading === 8 ? 'green' : 'rgb(125 227 251)', fontSize: '0.625rem', border: 0, color: 'white', borderRadius: '20px', float: 'right', padding: 8, paddingLeft: '16px', paddingRight: 16 }}>
                        UPDATE</Button>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ fontWeight: 600 }}>Email 4</td>
                    <td style={{ padding: 0 }}>
                      <div className="pl-lg-4">
                        <Row>
                          <Col md="12" style={{ padding: 10 }}>
                            <div>
                              <Input
                                type="text"
                                style={{ color: '#62635e' }}
                                value={settings.mobile_number_2 ? settings.email_4 : ''}
                                onChange={(e) => setSettings({ ...settings, email_4: e.target.value })}
                              />
                            </div>
                            {error === 'email_4' ? <span style={{ color: 'red' }}>{'Enter a valid email address'}</span> : null}
                          </Col>
                        </Row>
                      </div>
                    </td>
                    <td>
                      <Button disabled={loading === 9} type="submit" onClick={() => onSettingsUpdate('email_4', 9)} style={{ backgroundColor: loading === 9 ? 'green' : 'rgb(125 227 251)', fontSize: '0.625rem', border: 0, color: 'white', borderRadius: '20px', float: 'right', padding: 8, paddingLeft: '16px', paddingRight: 16 }}>
                        UPDATE</Button>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ fontWeight: 600 }}>IOS Version</td>
                    <td style={{ padding: 0 }}>
                      <div className="pl-lg-4">
                        <Row>
                          <Col md="12" style={{ padding: 10 }}>
                            <div>
                              <Input
                                type="text"
                                style={{ color: '#62635e' }}
                                value={settings.ios_version ? settings.ios_version : ''}
                                onChange={(e) => setSettings({ ...settings, ios_version: e.target.value })}
                              />
                            </div>
                            {/* {error === 'email_3' ? <span style={{ color: 'red' }}>{'Enter a valid email address'}</span> : null} */}
                          </Col>
                        </Row>
                      </div>
                    </td>
                    <td>
                      <Button disabled={loading === 10} type="submit" onClick={() => onSettingsUpdate('ios_version', 10)} style={{ backgroundColor: loading === 10 ? 'green' : 'rgb(125 227 251)', fontSize: '0.625rem', border: 0, color: 'white', borderRadius: '20px', float: 'right', padding: 8, paddingLeft: '16px', paddingRight: 16 }}>
                        UPDATE</Button>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ fontWeight: 600 }}>Android Version</td>
                    <td style={{ padding: 0 }}>
                      <div className="pl-lg-4">
                        <Row>
                          <Col md="12" style={{ padding: 10 }}>
                            <div>
                              <Input
                                type="text"
                                style={{ color: '#62635e' }}
                                value={settings.android_version ? settings.android_version : ''}
                                onChange={(e) => setSettings({ ...settings, android_version: e.target.value })}
                              />
                            </div>
                            {/* {error === 'email_3' ? <span style={{ color: 'red' }}>{'Enter a valid email address'}</span> : null} */}
                          </Col>
                        </Row>
                      </div>
                    </td>
                    <td>
                      <Button disabled={loading === 11} type="submit" onClick={() => onSettingsUpdate('android_version', 11)} style={{ backgroundColor: loading === 11 ? 'green' : 'rgb(125 227 251)', fontSize: '0.625rem', border: 0, color: 'white', borderRadius: '20px', float: 'right', padding: 8, paddingLeft: '16px', paddingRight: 16 }}>
                        UPDATE</Button>
                    </td>
                  </tr>
                </tbody>
              </Table>
            </Card>
          </div>
        </Row>
      </Container>
      <Modal isOpen={modalOpen} size="sm">
        <ModalBody style={{ backgroundColor: 'rgb(219 219 147)', color: 'white' }}>Your session has expired. Please sign in again.</ModalBody>
        <ModalFooter>
          <Button onClick={() => onLogout()} style={{ backgroundColor: '#09577C', color: 'white' }} type="button">
            LOGOUT
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={peropen} size="sm">
        <ModalBody style={{ color: 'red' }}>You have no acess to change it..!</ModalBody>
        <div style={{ display: 'flex', justifyContent: 'center', paddingBottom: 20 }}>
          <Button onClick={() => permodalClose()} style={{ backgroundColor: 'red', color: 'white', border: 0 }}>Ok</Button>
        </div>
      </Modal>
      <Modal isOpen={editsucess} size="sm">
        <ModalBody style={{ color: 'green' }}> Updated successfully!</ModalBody>
      </Modal>
    </>
  );
};

export default Settings;